import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { checkAuthState } from './utils/auth';

// core components
import Login from './components/login';
import ChangePassword from './components/changePassword';
import RateService from './components/rateService';

// routes
import Main from './containers/main';
import routesHome from './containers/home/routes';
import routesRequests from './containers/request/routes';
import routesConfig from './containers/config/routes';
import routesPolicy from './containers/policy/routes';

const RestrictedRoute = ({ component: Component = Main, isLoggedIn, router, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component router={router} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const DefaultRoutes = ({ history, isLoggedIn }) => (
  <ConnectedRouter history={history}>
    <Switch>
      {/* Loads public routes */}
      {/* <Route 
          exact 
          path={"/"} 
          component = {Dashboard} /> */}

      <Route exact path={'/login'} component={Login} />
      <Route path={'/rateService'} component={RateService} />

      {/* Loads restricted routes */}
      <RestrictedRoute exact path={'/'} router={routesHome} isLoggedIn={isLoggedIn} />
      <RestrictedRoute exact path={'/home'} router={routesHome} isLoggedIn={isLoggedIn} />
      <RestrictedRoute exact path={'/resetPassword'} component={ChangePassword} isLoggedIn={isLoggedIn}/>
      <RestrictedRoute
        // exact
        path={'/requests'}
        router={routesRequests}
        isLoggedIn={isLoggedIn}
      />
      <RestrictedRoute exact path={'/config'} router={routesConfig} isLoggedIn={isLoggedIn} />
      <RestrictedRoute exact path="/policy" router={routesPolicy} isLoggedIn={isLoggedIn} />

      {/* requests
      config */}

      {/* <RestrictedRoute
        path={"/clients"}
        router={route}
        isLoggedIn={isLoggedIn}
      />
      <RestrictedRoute
        path={"/admin"}
        router={routesAdmin}
        isLoggedIn={isLoggedIn}
      /> */}
    </Switch>
  </ConnectedRouter>
);

export default connect(state => ({
  isLoggedIn: checkAuthState(state),
}))(DefaultRoutes);
